"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextFileIcon;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));
function TextFileIcon(props) {
  let path = /*#__PURE__*/_react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, "Ic\xF4ne de fichier texte"), /*#__PURE__*/_react.default.createElement("path", {
    fill: "inherit",
    d: "M870.402 34.133v955.734c0 9.422-7.641 17.063-17.070 17.063h-682.664c-9.422 0-17.063-7.641-17.063-17.063v-802.133h170.664v-170.664h529.063c9.43 0 17.070 7.641 17.070 17.063z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "inherit",
    d: "M324.269 17.070v170.664h-170.664z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M170.668 1024h682.664c18.852 0 34.133-15.281 34.133-34.133v-955.734c0-18.852-15.281-34.133-34.133-34.133h-529.063c-0.359 0-0.664 0.188-1.023 0.203-1.555 0.102-3.086 0.414-4.555 0.922-0.539 0.164-1.070 0.359-1.594 0.578-1.758 0.813-3.375 1.906-4.773 3.25l-170.672 170.75c-1.352 1.406-2.453 3.047-3.258 4.828-0.211 0.523-0.406 1.063-0.563 1.602-0.508 1.461-0.82 2.984-0.922 4.523 0 0.375-0.203 0.688-0.203 1.039v85.336c0 9.43 7.641 17.070 17.063 17.070 9.43 0 17.070-7.641 17.070-17.070v-68.234h153.602c9.422 0 17.063-7.641 17.063-17.063v-153.602h511.828v955.734h-682.664v-648.531c0-9.43-7.641-17.070-17.063-17.070-9.43 0-17.070 7.641-17.070 17.070v648.531c0 18.852 15.281 34.133 34.133 34.133zM307.199 170.664h-112.398l112.398-112.398z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M256.004 290.133h307.195c9.43 0 17.070-7.641 17.070-17.063 0-9.43-7.641-17.070-17.070-17.070h-307.195c-9.43 0-17.070 7.641-17.070 17.070 0 9.422 7.641 17.063 17.070 17.063z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M256.004 392.531h512c9.422 0 17.063-7.641 17.063-17.063 0-9.43-7.641-17.070-17.063-17.070h-512c-9.43 0-17.070 7.641-17.070 17.070 0 9.422 7.641 17.063 17.070 17.063z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M256.004 494.93h512c9.422 0 17.063-7.641 17.063-17.063 0-9.43-7.641-17.070-17.063-17.070h-512c-9.43 0-17.070 7.641-17.070 17.070 0 9.422 7.641 17.063 17.070 17.063z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M256.004 597.336h512c9.422 0 17.063-7.641 17.063-17.070 0-9.422-7.641-17.063-17.063-17.063h-512c-9.43 0-17.070 7.641-17.070 17.063 0 9.43 7.641 17.070 17.070 17.070z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M256.004 699.734h512c9.422 0 17.063-7.641 17.063-17.070 0-9.422-7.641-17.063-17.063-17.063h-512c-9.43 0-17.070 7.641-17.070 17.063 0 9.43 7.641 17.070 17.070 17.070z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M256.004 802.133h512c9.422 0 17.063-7.641 17.063-17.063 0-9.43-7.641-17.070-17.063-17.070h-512c-9.43 0-17.070 7.641-17.070 17.070 0 9.422 7.641 17.063 17.070 17.063z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M682.668 870.398c-9.422 0-17.063 7.641-17.063 17.070 0 9.422 7.641 17.063 17.063 17.063h51.203c9.422 0 17.063-7.641 17.063-17.063 0-9.43-7.641-17.070-17.063-17.070z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M358.402 870.398c-9.43 0-17.070 7.641-17.070 17.070 0 9.422 7.641 17.063 17.070 17.063h256c9.422 0 17.063-7.641 17.063-17.063 0-9.43-7.641-17.070-17.063-17.070z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M256.004 904.531h34.133c9.422 0 17.063-7.641 17.063-17.063 0-9.43-7.641-17.070-17.063-17.070h-34.133c-9.43 0-17.070 7.641-17.070 17.070 0 9.422 7.641 17.063 17.070 17.063z"
  }));
  return path;
}
